var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cmpCreate',{ref:"cmpCreate",attrs:{"name":_vm.name,"subPath":_vm.subPath,"pkColumn":_vm.pkColumn,"fields":_vm.fields,"parent":_vm.parent,"header":_vm.header,"goBackAfterCreate":_vm.goBackAfterCreate},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }